"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.goldStorageConfig = void 0;
exports.goldStorageConfig = {
    name: 'storage-gold',
    fullname: 'Gold Storage',
    description: 'Storage for gold ingots and gold ore.',
    type: 'storage',
    width: 1,
    height: 1,
    levelMax: 9,
    canBeDisabled: false,
    requiredTechnology: 'gold',
    levels: [
        { level: 0, constructionCosts: {}, time: 1, provides: {}, costs: {}, stores: { gold: 10 } },
        { level: 1, constructionCosts: { iron: 5 }, time: 1, provides: {}, costs: {}, stores: { gold: 20 } },
        { level: 2, constructionCosts: { iron: 10 }, time: 1, provides: {}, costs: {}, stores: { gold: 40 } },
        { level: 3, constructionCosts: { iron: 30 }, time: 1, provides: {}, costs: {}, stores: { gold: 100 } },
        { level: 4, constructionCosts: { iron: 70 }, time: 1, provides: {}, costs: {}, stores: { gold: 200 } },
        { level: 5, constructionCosts: { iron: 150 }, time: 1, provides: {}, costs: {}, stores: { gold: 400 } },
        { level: 6, constructionCosts: { iron: 300 }, time: 1, provides: {}, costs: {}, stores: { gold: 1000 } },
        { level: 7, constructionCosts: { iron: 500 }, time: 1, provides: {}, costs: {}, stores: { gold: 2000 } },
        { level: 8, constructionCosts: { iron: 1000 }, time: 1, provides: {}, costs: {}, stores: { gold: 3000 } },
        { level: 9, constructionCosts: { iron: 2000 }, time: 1, provides: {}, costs: {}, stores: { gold: 5000 } },
    ],
};



//////////////////
// WEBPACK FOOTER
// ../engine/dist/config/buildings/goldstorage.js
// module id = aYJT
// module chunks = 0